<template>
  <div>
    <b-field
      :label="title"
      :label-position="'on-border'">
      <template>
        <b-field>
          <b-select
            v-if="type==='select'"
            :id="id"
            v-model="formattedInput"
            :placeholder="placeholder"
            rounded
            expanded>
            <option
              v-for="(option, j) in options"
              :key="`option-${j}`"
              :value="option.value">
              {{ option.label }}
            </option>
          </b-select>
          <b-switch
            v-else-if="type==='switch' && termType===selfTermType"
            :id="id"
            v-model="formattedInput"
            v-bind="$attrs">
            {{ placeholder }}
          </b-switch>
          <b-input
            v-else-if="type==='text'"
            :id="id"
            v-model="formattedInput"
            :type="type"
            rounded
            :icon="icon ||''"
            :placeholder="placeholder"
            v-bind="$attrs"
            expanded />
          <b-input
            v-else-if="type==='number'"
            :id="id"
            v-model="formattedInput"
            rounded
            :icon="icon ||''"
            :placeholder="placeholder"
            v-bind="$attrs"
            expanded />
        </b-field>
      </template>
    </b-field>
  </div>
</template>

<script>
import { formattedToValue, valueToFormatted } from 'creditu-types/format';

export default {
  name: 'BaseInput',
  props: {
    value: [Number, String, Boolean, Array], // Este prop es usado para poder usar v-model desde quien implemente este componente
    type: { type: String },
    formatType: { type: String },
    termType: { type: String },
    selfTermType: { type: String },
    title: { type: String },
    placeholder: { type: String },
    options: { type: Array },
    icon: { type: String },
    id: { type: String }
  },
  data() {
    return {
      formattedInput: ''
    };
  },
  watch: {
    /**
     * value es el prop usado para poder usar la característica v-model, cuando cambia significa
     * que el componente padre le asignó un valor desde afuera, en ese caso entonces acutalizamos
     * el valor de formattedInput que es la variable usada en el b-input
     */
    value: {
      immediate: true,
      handler(val) {
        if (this.type === 'number' && val !== null) {
          this.formattedInput = valueToFormatted(this.formatType, this.$i18n.locale, val, 0);
          return;
        }
        this.formattedInput = val || '';
      }
    },
    /**
     * Si es que cambia el valor de formattedInput, que es la variable usada en b-input, entonces
     * hay que emitir un evento input para que AmountForm.vue lo pueda escuchar en el v-model
     * Si el BaseInput tiene type currencyNumber, entonces se debe emitir un número en vez de un string
     */
    formattedInput(val) {
      if (this.type === 'number' && val !== null) {
        const formatted = formattedToValue(this.formatType, this.$i18n.locale, val);
        this.$emit('input', formatted);
        return;
      }
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
